import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const commonVehicleSchema = Yup.object().shape({
  year: Yup.string().nullable(),
  make: Yup.string().nullable(),
  model: Yup.string().nullable(),
  body: Yup.string().nullable(),
  color: Yup.string().nullable(),
  titleNumber: Yup.string().nullable(),
  titleState: Yup.string().nullable(),
  registrationExpiration: Yup.string().nullable(),
})

const vehiclesSchemaCustom = Yup.object()
  .shape({
    plateNumber: Yup.string().nullable(),
    plateState: Yup.string().nullable(),
  })
  .concat(commonVehicleSchema)

const validationSchema = Yup.object()
  .shape({
    plateNumber: Yup.string().nullable().required('Plate Number is required'),
    plateState: Yup.string().nullable().required('Plate State is required'),
  })
  .concat(commonVehicleSchema)

export const vehiclesSchema = {
  vehiclesArray: Yup.array().of(vehiclesSchemaCustom),
}

export const formOptions = {
  resolver: yupResolver(
    Yup.object().shape({
      vehicle: validationSchema,
    }),
  ),
}

const scrapVehicleSchema = Yup.object().shape({
  vehicle: Yup.object().shape({
    vin: Yup.string()
      .nullable()
      .required('VIN is required')
      .test(
        'length',
        'VIN must contain 17 characters. Please check the VIN and try again',
        val => val.toString().length === 17,
      ),
  }),
})

export const scrapVehicleFormOptions = {
  resolver: yupResolver(scrapVehicleSchema),
}

export default validationSchema
